import { useEffect } from 'react';
import useAgencyBranding from 'app/hooks/useAgencyBranding';

const DEFAULT_FAVICON = 'https://www.service.nsw.gov.au/modules/custom/snsw_favicon/images/favicon-16x16.png';
const DEFAULT_SHORTCUT_ICON = 'https://www.service.nsw.gov.au/modules/custom/snsw_favicon/images/favicon.ico';
const DEFAULT_TITLE = 'Online Bookings | NSW Government';

const DEFAULT_FAVICON_SIZE = '16x16';

const updateFavicon = (favicon: string, shortcutIcon?: string, faviconType?: string, faviconSize?: string) => {
  const iconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  const shortcutLink = document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');

  if (iconLink) {
    iconLink.href = favicon;
    iconLink.type = faviconType || 'image/png';
    iconLink.setAttribute('sizes', faviconSize || DEFAULT_FAVICON_SIZE);
  }

  if (shortcutLink) {
    shortcutLink.href = shortcutIcon || favicon;
    shortcutLink.type = faviconType || 'image/vnd.microsoft.icon';
  }
};

const updateTitle = (title: string) => {
  document.title = title;
};

const useFavicon = (): void => {
  const { branding: agency } = useAgencyBranding();

  useEffect(() => {
    const matchedConfig = agency?.favicon;

    if (matchedConfig) {
      updateFavicon(
        matchedConfig.favicon,
        matchedConfig.shortcutIcon,
        matchedConfig.faviconType,
        matchedConfig.faviconSize,
      );
      updateTitle(matchedConfig.title);
    } else {
      updateFavicon(DEFAULT_FAVICON, DEFAULT_SHORTCUT_ICON);
      updateTitle(DEFAULT_TITLE);
    }
  }, [agency]);
};

export default useFavicon;
